"use client";

import { useState } from "react";
import Link from "next/link";
import { FaEnvelope } from "react-icons/fa";
import { SiX, SiInstagram, SiLinkedin } from "react-icons/si";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import ModalPortal from "@/components/custom/modal-portal";
import { FocusTrap } from "focus-trap-react";
import PrivacyPolicyContent from "@/app/transparency/privacy-policy/privacy-policy";
import TermsOfUseContent from "@/app/transparency/terms-of-use/terms-of-use";

export default function GrinsperBigFooter() {
	const [modalContent, setModalContent] = useState<"privacy" | "terms" | null>(null);
	return (
		<>
			<footer
				id="grinsper-big-footer"
				className="w-full bg-[#0f172a] text-gray-200 py-12 px-6 mt-0">
				<div className="max-w-7xl mx-auto">
					{/*<div className="hidden md:grid grid-cols-1 md:grid-cols-4 gap-10">
						<div>
							<h3 className="text-lg font-semibold mb-3 text-white">Sobre a Grinsper</h3>
							<p className="text-sm mb-4">
								A <b>Grinsper</b> analisa o comportamento observável de produtos digitais para evidenciar sinais de Privacy Drift, apoiando organizações na identificação de riscos e oportunidades de melhoria em privacidade.
							</p>
						</div>

						<div>
							<h3 className="text-lg font-semibold mb-3 text-white">Missão</h3>
							<p className="text-sm mb-4">
								Transformar o comportamento observável de produtos digitais em evidências que apoiem decisões técnicas, regulatórias e de negócio relacionadas à privacidade.
							</p>
							<h4 className="text-md font-semibold mb-2 text-white">Valores</h4>
							<p className="text-sm text-gray-300">
								Autonomia • Transparência • Confiança
							</p>
						</div>

						<div>
							<h3 className="text-lg font-semibold mb-3 text-white">Soluções</h3>
							<ul className="text-sm space-y-2 mb-6">
								<li>
									<Link href="#grinsper-form" className="hover:underline text-gray-300">
										Análise Privacy Drift
									</Link>
									<p className="text-xs text-gray-400 mt-0.5 leading-relaxed">
										Analise desvios de privacidade no seu produto
									</p>
								</li>
								<li><Link href="#" className="hover:underline text-gray-300">Blog</Link></li>
								<li><Link href="#" className="hover:underline text-gray-300">Institucional</Link></li>
							</ul>
						</div>

						<div>
							<h3 className="text-lg font-semibold mb-3 text-white">Transparência</h3>
							<ul className="text-sm space-y-2 mb-6">
								<li>
									<button type="button" className="text-gray-300" onClick={() => setModalContent("privacy")}>Política de Privacidade</button>
								</li>
								<li>
									<button type="button" className="text-gray-300" onClick={() => setModalContent("terms")}>Termos de Uso</button>
								</li>
							</ul>
							<h3 className="text-lg font-semibold mb-3 text-white">Contato</h3>
							<ul className="text-sm space-y-2">
								<li className="flex items-center gap-2">
									<FaEnvelope className="w-5 h-5 inline mr-2" />
									<a href="mailto:contato@grinsper.com"
										title="Enviar mensagem para a Grinsper"
										className="hover:underline text-gray-300"
										aria-label="Enviar e-mail para contato@grinsper.com"
									>
										contato@grinsper.com
									</a>
								</li>
								<li className="flex items-center gap-2">
									<SiInstagram className="w-5 h-5 inline mr-2" />
									<a href="https://instagram.com/grinsper.gpx"
										target="_blank"
										rel="noopener"
										className="hover:underline text-gray-300"
										aria-label="Instagram da Grinsper"
									>
										Grinsper no Instagram
									</a>
								</li>
								<li className="flex items-center gap-2">
									<SiLinkedin className="w-5 h-5 inline mr-2" />
									<a href="https://linkedin.com/company/grinsper"
										target="_blank"
										rel="noopener"
										className="hover:underline text-gray-300"
										aria-label="Página LinkedIn da Grinsper"
									>
										Grinsper no LinkedIn
									</a>
								</li>
							</ul>
						</div>
					</div>

					<div className="md:hidden">
						<Accordion type="multiple">
							<AccordionItem value="sobre">
								<AccordionTrigger>Sobre a Grinsper</AccordionTrigger>
								<AccordionContent>
									<p className="text-sm">
										A <b>Grinsper</b> analisa o comportamento observável de produtos digitais para evidenciar sinais de Privacy Drift, apoiando organizações na identificação de riscos e oportunidades de melhoria em privacidade.
									</p>
								</AccordionContent>
							</AccordionItem>
							<AccordionItem value="missao">
								<AccordionTrigger>Missão</AccordionTrigger>
								<AccordionContent>
									<p className="text-sm mb-2">
										Transformar o comportamento observável de produtos digitais em evidências que apoiem decisões técnicas, regulatórias e de negócio relacionadas à privacidade.
									</p>
								</AccordionContent>
							</AccordionItem>
							<AccordionItem value="valores">
								<AccordionTrigger>Valores</AccordionTrigger>
								<AccordionContent>
									<p className="text-sm">
										Autonomia • Transparência • Confiança
									</p>
								</AccordionContent>
							</AccordionItem>
							<AccordionItem value="solucoes">
								<AccordionTrigger>GPX Test™</AccordionTrigger>
								<AccordionContent>
									<ul className="text-sm space-y-2 mb-4">
										<li>
											<Link href="#grinsper-form" className="hover:underline text-gray-300">
												Análise Privacy Drift
											</Link>
											<p className="text-xs text-gray-400 mt-0.5 leading-relaxed">
												Analise desvios de privacidade no seu produto
											</p>
										</li>
										<li><Link href="#" className="hover:underline text-gray-300">Blog</Link></li>
										<li><Link href="#" className="hover:underline text-gray-300">Institucional</Link></li>
									</ul>
								</AccordionContent>
							</AccordionItem>
							<AccordionItem value="transparencia">
								<AccordionTrigger>Transparência</AccordionTrigger>
								<AccordionContent>
									<ul className="text-sm space-y-2">
										<li>
											<button type="button" className="text-gray-300" onClick={() => setModalContent("privacy")}>Política de Privacidade</button>
										</li>
										<li>
											<button type="button" className="text-gray-300" onClick={() => setModalContent("terms")}>Termos de Uso</button>
										</li>
									</ul>
								</AccordionContent>
							</AccordionItem>
							<AccordionItem value="contato">
								<AccordionTrigger>Contato</AccordionTrigger>
								<AccordionContent>
									<ul className="text-sm space-y-2">
										<li className="flex items-center gap-2">
											<FaEnvelope className="w-5 h-5 inline mr-2" />
											<a href="mailto:contato@grinsper.com"
												title="Enviar mensagem para a Grinsper"
												className="hover:underline text-gray-300"
												aria-label="Enviar e-mail para contato@grinsper.com"
											>
												contato@grinsper.com
											</a>
										</li>
										<li className="flex items-center gap-2">
											<SiInstagram className="w-5 h-5 inline mr-2" />
											<a href="https://instagram.com/grinsper.gpx"
												target="_blank"
												rel="noopener"
												className="hover:underline text-gray-300"
												aria-label="Instagram da Grinsper"
											>
												Grinsper no Instagram
											</a>
										</li>
										<li className="flex items-center gap-2">
											<SiLinkedin className="w-5 h-5 inline mr-2" />
											<a href="https://linkedin.com/company/grinsper"
												target="_blank"
												rel="noopener"
												className="hover:underline text-gray-300"
												aria-label="Página da Grinsper no LinkedIn"
											>
												Grinsper no LinkedIn
											</a>
										</li>
									</ul>
								</AccordionContent>
							</AccordionItem>
						</Accordion>
					</div>*/}

					<div className="mt-10 border-t border-gray-700 pt-6 text-center text-sm text-gray-500">
						© {new Date().getFullYear()} Grinsper. Todos os direitos reservados.
					</div>
				</div>
				{modalContent && (
					<ModalPortal>
						<FocusTrap>
							<div role="dialog"
								aria-modal="true"
								className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[999] p-4">
								<div className="bg-white p-8 rounded-2xl max-w-2xl w-full relative shadow-2xl">
									<button className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-xl focus:outline-none" aria-label="Fechar modal"
										onClick={() => setModalContent(null)}>✕</button>
									<h2 className="text-xl font-bold mb-6 text-gray-900 border-b pb-4">
										{modalContent === "privacy" ? "Grinsper :: Política de Privacidade" : "Grinsper :: Termos de Uso"}
									</h2>
									<div className="overflow-y-auto max-h-[60vh] text-sm text-gray-700 pr-2 custom-scrollbar">
										{modalContent === "privacy" ? (
											<PrivacyPolicyContent />
										) : (
											<TermsOfUseContent />
										)}
									</div>
								</div>
							</div>
						</FocusTrap>
					</ModalPortal>
				)}
			</footer >
		</>

	);
}
